import { WAITING } from '../actions/types';

export default function waitingReducer(state = [], action) {
	switch (action.type) {
		case WAITING:
			return action.payload || false;
		default:
			return state;
	}
}
